import React from 'react'
import {ModalBox, ModalWrap} from 'src/styles/common/modal'
import AlertModal from './AlertModal'
import useModalText from "src/hooks/useModalText";
import TermsModal from "src/component/common/Modal/TermsModal";
import SecurityModal from "src/component/common/Modal/SecurityModal";
import TimeOfBirth from "src/component/common/Modal/TimeOfBirth";
import useWindowDimensions from "src/hooks/useGetWindowSize";
import NoticeModal from "src/component/common/Modal/NoticeModal"
import MVNOModal from './MVNOModal';
import RefundModal from './RefundModal';

const Modal = (props: any) => {
    const {isOpen, toggle, doubleToggle, type, ClickFunc, ClickFunc2, ClickFunc3, option, setOption} = props
    const modalOption = useModalText()
    const {width} = useWindowDimensions()
    const TextItem = modalOption?.ModalTextOptions?.find((element: any) => element.idx === setOption)

    const caseByClickFunc = () => {
        switch (true) {
            case (option === "서비스 해지가 완료되었습니다.\n가입 당일 해지 고객은 요금이 부과되지 않습니다.") :
            case (option?.title === "서비스 해지 및 환불 접수 완료"):
                toggle()
                window.location.reload()
                break;
            case (option === "요청 정보가 없습니다."):
            case (option === "인증번호 3회 오류로 만료되었습니다. 다시 진행해 주세요."):
                window.location.reload()
                break
            default:
                return ClickFunc()
        }
    }
    const InnerComponent = (type: any) => {
        switch (type) {
            case 'alert':
                return <AlertModal option={setOption === 0 ? option : TextItem?.title} ClickFunc={caseByClickFunc}/>
            case 'terms' :
                return <TermsModal option={option} ClickFunc={ClickFunc}/>
            case 'MVNO' :
                return <MVNOModal option={option} ClickFunc={toggle} ClickFunc1={ClickFunc} ClickFunc2={ClickFunc2}/>
            case 'security' :
                return <SecurityModal isOpen={isOpen} ClickFunc={toggle} ClickFunc2={doubleToggle} ClickFunc3={ClickFunc3} />
            case 'timeOfBirth' :
                return <TimeOfBirth ClickFunc={ClickFunc}/>
            case 'notice' :
                return <NoticeModal isOpen={isOpen} ClickFunc={toggle}/>
            case 'refund':
                return <RefundModal option={option} ClickFunc={caseByClickFunc}/>
        }
    }

    return (
        <ModalWrap toggle={isOpen} zIndex={9990} width={`${width}px`}>
            <ModalBox onClick={(e: any) => e.stopPropagation()}>
                {InnerComponent(type)}
            </ModalBox>
        </ModalWrap>
    )
}
export default Modal
